import { render } from "./EpayPayment.vue?vue&type=template&id=29ff9ecf"
import script from "./EpayPayment.vue?vue&type=script&lang=js"
export * from "./EpayPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__